import { ExtendedFeatureSettings } from '@mbrtargeting/metatag-shared-types';
import { inject, injectionTarget } from '../../../loader/decorators/inject.js';
import { ConfigResolver } from '../../../loader/essentials/config-resolver.js';
import { selectFeatureSettings } from '../../../loader/essentials/config-selector.js';
import { logger } from '../../../loader/essentials/logger.js';
import { CONFIG_RESOLVER } from '../../../loader/token.js';

const log = logger.logGroup({ prefix: 'FeatureController' });

@injectionTarget()
export class FeatureController {

    @inject(CONFIG_RESOLVER) private configResolver!: ConfigResolver;

    /**
     * allows us to add background color & clickable and change features for while specific special formats are displayed
     * @param newFeatureSettings featureSettings that should be overwritten
     */
    public editFeatures(newFeatureSettings: Partial<ExtendedFeatureSettings>) {
        this.configResolver.update(selectFeatureSettings(), featureSettings => ({
            ...featureSettings,
            ...newFeatureSettings
        }));
    }
}
